import { useWizard } from "react-use-wizard";
import BaseStep from "../../../../../../shared/wizard/steps/baseStep";
import TextArea from "../../../../../../ui/textArea";
import { TKeyOfDataWizardBuy, TStringKeysOfIFillDataWizardBuy } from "../..";
import styles from "./styles.module.scss";
import buySteps from "../buySteps";
interface ISureStep_1 {
  data: string | null;
  onChange: (data: string, key: TStringKeysOfIFillDataWizardBuy) => void;
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
}

const SureStepBuy_1 = ({ data, onChange, onReset }: ISureStep_1) => {
  const { goToStep } = useWizard();

  const handleNextStep = () => {
    goToStep(buySteps.sureSteps.step_2);
  };

  const handlePrevStep = () => {
    goToStep(buySteps.step_1);
    onReset(["freeComment"]);
  };

  const handleChange = (data: string) => {
    onChange(data, "freeComment");
  };

  return (
    <div className={styles.stepBuy_1}>
      <BaseStep
        prevStep={handlePrevStep}
        nextStep={handleNextStep}
        text="Кратко опишите какую квартиру вы желаете:"
      >
        <div className={styles.stepBuy_1__textArea}>
          <TextArea
            onChange={handleChange}
            value={data ? data : ""}
            placeholder="Просторная трехкомнатная квартира в центре города."
          />
        </div>
      </BaseStep>
    </div>
  );
};

export default SureStepBuy_1;
